import * as z from 'zod';
export const ReservableStatus = z.enum(['available', 'in_use']);
